export default {
  "finishAuthority": "Solo quien lleva la tarjeta puede finalizar la ronda.",
  "finishDraft": "Confirma o restablece los resultados en borrador antes de finalizar.",
  "finishScoreRetry": "Los resultados no se han guardado. Revisa tu conexión y reintenta.",
  "finishSavingScores": "Esperando la confirmación de guardado de los resultados.",
  "finishStatsRetry": "Resuelve o reintenta las estadísticas sin guardar en Hoyo.",
  "finishSavingStats": "Esperando a que se guarden tus estadísticas.",
  "finishMissingScores": "Cada jugador necesita un resultado confirmado en cada hoyo.",
  "finishingRound": "Finalizando…",
  "holeSaveError": "No se pudo guardar el hoyo que estás viendo. Los resultados se guardan por separado.",

  "scorecardHeading": "Tarjeta de resultados",
  "playersScored": "{count} de {total} jugadores con resultado",
  "yourScorecard": "Tu tarjeta",
  "roundView": "Vista de ronda",
  "scoreCoverageShort": "{count} de {total} rondas comparables",
  "offline": "Sin conexión — pendiente de guardar",
  "noPutts": "Aún no hay putts registrados",
  "excludedReasons": "Excluidas en este período: {scores} rondas con resultados incompletos; {par} rondas sin par histórico.",
  "playVideo": "Reproducir vídeo del hoyo {number}",
  "pauseVideo": "Pausar vídeo del hoyo {number}",
  "puttChoice": "{count} putts",
  "exactPutts": "Número exacto de putts",
  "apply": "Aplicar",
  "cancel": "Cancelar",
  "tapToClear": "Toca una respuesta seleccionada para borrarla.",
  "personal": "Mi tarjeta",
  "group": "Grupo",
  "cardView": "Vista de tarjeta",
  "unrecorded": "Sin registrar",
  "strokes": "golpes registrados",
  "scoredCoverage": "{count} de {total} hoyos con resultado",
  "parCoverage": "{count} hoyos con par fiable",
  "legend": "Ayuda de tarjeta",
  "legendHelp": "FW: calle. GIR: green en regulación. ✓ Acertada / Sí; × Fallada / No; — sin registrar; N/A no aplicable. Toca un número de hoyo para volver.",
  "hole": "Hoyo",
  "par": "Par",
  "score": "Resultado",
  "goHole": "Ir al hoyo {number}",
  "recordedStrokes": "Golpes registrados",
  "continueHole": "Continuar en el hoyo {number}",
  "draft": "Borrador",
  "holePosition": "{number} / {total}",
  "holeNumber": "Hoyo {number}",
  "strokeIndex": "Índice",
  "metres": "m",
  "yards": "yd",
  "card": "Tarjeta",
  "finishRound": "Finalizar ronda",
  "swipeCard": "Tarjeta de hoyo deslizable",
  "holeNavigation": "Navegación de hoyos",
  "previousHole": "Hoyo anterior",
  "nextHole": "Siguiente hoyo",
  "reviewCard": "Revisar tarjeta",
  "guest": "Invitado",
  "scorer": "Anotador",
  "member": "Socio",
  "toPar": "respecto al par",
  "reset": "Restablecer",
  "confirmScore": "Confirmar {score}",
  "decreaseScore": "Reducir resultado de {name}",
  "increaseScore": "Aumentar resultado de {name}",
  "confirmPlayerScore": "Confirmar resultado {score} de {name}",
  "draftScore": "Resultado provisional {score}",
  "savedScore": "Resultado guardado {score}",
  "keepingCard": "{name} lleva esta tarjeta.",
  "scoringTrend": "Evolución del resultado",
  "viewData": "Ver datos",
  "roundsLogged": "Rondas registradas",
  "recentRounds": "Rondas recientes",
  "firstTitle": "Tu progreso empieza con una ronda",
  "firstHelp": "Completa una ronda para seguir tus resultados. Las estadísticas opcionales te ayudan a conocer tu juego.",
  "startRound": "Empezar una ronda",
  "puttingHelp": "Cuenta tus golpes en el green.",
  "fairwayHelp": "Indica si tu salida llega a la calle en hoyos de par 4 y 5.",
  "noMatch": "Ninguna ronda coincide con estos filtros",
  "noMatchHelp": "Elige otro campo, salida o número de hoyos para ver tus rondas.",
  "resetFilters": "Restablecer filtros",
  "benchmark": "Tu primera referencia",
  "benchmarkHelp": "Otra ronda comparable iniciará una tendencia.",
  "whyOne": "¿Por qué solo una ronda?",
  "excludedHelp": "Otras {count} rondas de este período carecen de resultados completos o par histórico fiable.",
  "historicalHelp": "Tus rondas están aquí. Registra resultados y estadísticas opcionales en futuras rondas para seguir tu progreso.",
  "noScoring": "Aún no hay rondas comparables",
  "puttingTab": "Putting",
  "fairwaysTab": "Calles",
  "greensTab": "GIR",
  "perHole": "putts / hoyo registrado",
  "coverage": "Cobertura registrada",
  "loggedCoverage": "{count} completadas en este período",
  "viewRounds": "Ver rondas",
  "roundUnavailable": "Esta ronda no está disponible.",
  "returnGolf": "Volver a Golf",
  "loadingCard": "Cargando tu tarjeta",
  "restoringCard": "Restaurando el hoyo actual y los resultados",
  "completeError": "Todos los jugadores necesitan un resultado en cada hoyo para finalizar la ronda.",
  "stablefordNote": "Resultado bruto · Puntos Stableford pendientes de hándicaps de juego oficiales",
  "missingImage": "Vista del hoyo no disponible",
  "roundComplete": "Ronda completada",

  "checkingLatest": "Comprobando los últimos valores guardados…",
  "conflictTitle": "Revisa las estadísticas modificadas",
  "conflictHelp": "Estas estadísticas han cambiado en otra sesión. Revisa los últimos valores y tu borrador.",
  "latestSaved": "Últimos valores guardados",
  "yourDraft": "Tu borrador sin guardar",
  "editedFieldsOnly": "Solo se guardarán los campos que has editado.",
  "useLatest": "Usar últimos valores",
  "confirmReviewed": "Guardar cambios revisados",
  "holeCount": "{count} hoyos",
  "evenPar": "Par",

  "score_changed_reload": "Este resultado ha cambiado en otra sesión. Se muestra el último guardado y se conserva tu valor como borrador. Revísalo y confírmalo de nuevo.",
  "putts_exceed_score": "El resultado es inferior a los putts registrados. Ajusta el resultado o pide al golfista que revise sus putts.",
  "answersRecorded": "{hits} de {count} registrados",
  "partialPutts": "{total} putts en {count} de {holes} hoyos registrados",
  "scoreSaveError": "No se ha podido guardar el resultado. Se conserva tu resultado. Comprueba la conexión y reintenta.",
  "title": "Mis estadísticas del hoyo",
  "optional": "Opcional",
  "support": "Añade tantos datos como quieras",
  "putts": "Putts",
  "fairway": "Calle",
  "gir": "Green en regulación",
  "girHelp": "Llegar al green en un máximo de par menos dos golpes.",
  "yes": "Sí",
  "no": "No",
  "hit": "Acertada",
  "missed": "Fallada",
  "clear": "Borrar",
  "clearAll": "Borrar estadísticas",
  "unknownPar": "Par histórico no disponible; no se puede registrar esta respuesta.",
  "na": "No aplica",
  "increase": "Aumentar putts",
  "decrease": "Reducir putts",
  "retry": "Reintentar",
  "saved": "Guardado",
  "saving": "Guardando…",
  "unsaved": "Sin guardar",
  "saveError": "No se han podido guardar las estadísticas. Tus cambios se conservan.",
  "progress": "Mi progreso en golf",
  "entrySubtitle": "Rondas, estadísticas y evolución",
  "subtitle": "Tu juego a lo largo del tiempo",
  "back": "Volver",
  "courseTee": "Campo / tees",
  "holes": "Hoyos",
  "period": "Periodo",
  "lastRounds": "Últimas {count} rondas",
  "allTime": "Todo el historial",
  "overview": "Resumen",
  "trends": "Tendencias",
  "rounds": "Rondas",
  "scoreToPar": "Resultado respecto al par",
  "average": "Media respecto al par",
  "best": "Mejor ronda",
  "roundStats": "Tus estadísticas de ronda",
  "viewTrends": "Ver tendencias",
  "putting": "Putts por hoyo",
  "fairways": "Calles acertadas",
  "greens": "Greens en regulación",
  "lower": "Cuanto menos, mejor",
  "higher": "Cuanto más, mejor",
  "par45": "Par 4 y 5",
  "recordedOnly": "Solo se incluyen las estadísticas registradas. Se excluyen los datos omitidos.",
  "holesRecorded": "{count} hoyos registrados",
  "roundCoverage": "{count} rondas completadas · {holes} hoyos en el periodo",
  "scoreCoverage": "{count} de {total} rondas con golpes completos y par histórico fiable.",
  "noMetric": "No hay datos registrados en este periodo.",
  "oneRound": "Una ronda registrada. Con más rondas podrás ver la tendencia.",
  "noHistory": "No hay rondas completadas",
  "emptyHelp": "Completa una ronda o cambia los filtros para ver tu progreso.",
  "window": "Historial completo, analizado en páginas de hasta 200 rondas. Los valores y gráficos corresponden a la página actual.",
  "loading": "Cargando tu progreso…",
  "loadError": "No hemos podido cargar tu progreso.",
  "chartDescription": "Rondas en orden cronológico. Se excluyen los datos omitidos. Abre los datos del gráfico para consultar fechas, valores y cobertura.",
  "chartData": "Datos del gráfico: fechas, valores y cobertura",
  "date": "Fecha",
  "value": "Valor",
  "recorded": "Hoyos registrados",
  "pagination": "Páginas del historial de rondas",
  "previous": "Anterior",
  "next": "Siguiente",
  "errors": {
    "invalid_putts": "Introduce un número entero de putts entre 0 y 30.",
    "putts_exceed_score": "Los putts no pueden superar los golpes guardados. Ajusta los putts o el resultado y reintenta.",
    "fairway_not_applicable": "Solo se pueden registrar calles en hoyos de par 4 y 5.",
    "par_unavailable": "El par histórico de este hoyo no está disponible.",
    "stats_changed_reload": "Otra solicitud ha cambiado estas estadísticas. Revisa tus datos antes de reintentar.",
    "round_not_editable": "Esta ronda ya no se puede editar. Tus cambios no se han guardado."
  }
}
